import get from "lodash/get";
import cloneDeep from "lodash/cloneDeep";

const initialState = {
  account: {},
  category: '',
  categoryObject: {},
  comment: '',
  competitiveReplacement: false,
  deleteProcessing: false,
  distributor: {},
  distributorId: null,
  entryDate: '',
  hours: 8,
  hoursMulti: [],
  id: '',
  interlock: {},
  interlockId: null,
  location: {},
  locationId: null,
  onsite: false,
  opportunity: {},
  opportunityId: null,
  productGroup: {},
  productGroupId: null,
  productLine: {},
  productLineId: null,
  serviceRequest: {},
  serviceRequestId: null,
  submitDate: '',
  submitProcessing: false,
  user: ''
};

export default function entryReducer(state = initialState, action) {
  switch (get(action, "type")) {
    case "SUBMITTING_ENTRY":
      return { ...state, submitProcessing: true };
    case "SUBMITTED_ENTRY":
      return { ...state, submitProcessing: false };
    case "DELETING_ENTRY":
      return { ...state, deleteProcessing: true };
    case "DELETED_ENTRY":
      return { ...state, deleteProcessing: false };
    case "SET_CATEGORY": {
      const categoryObject = (action.payload) ? action.payload : initialState.categoryObject;

      return {
        ...state,
        category: categoryObject.name,
        categoryId: categoryObject.id,
        categoryObject
      };
    }
    case "SET_ACCOUNT": {
      const account = (action.payload) ? action.payload : initialState.account;
      const accountMatches = state.accountId === account.accountId;

      return {
        ...state,
        account: account,
        accountId: account.accountId,
        location: accountMatches ? state.location : initialState.location,
        locationId: accountMatches ? state.locationId : initialState.locationId,
      };
    }
    case "SET_COMPETITIVE_REPLACEMENT":
      return { ...state, competitiveReplacement: Boolean(action.payload) };
    case "SET_DURATION":
      return {...state, hours: action.payload};
    case "SET_LOCATION": {
      const location = (action.payload) ? action.payload : initialState.location;

      return {
        ...state,
        location: location,
        locationId: location.standardLocationId
      };
    }
    case "SET_PRODUCT_GROUP": {
      const productGroup = (action.payload) ? action.payload : initialState.productGroup;

      return {
        ...state,
        productGroup: productGroup,
        productGroupId: productGroup.productGroupId
      };
    }
    case "SET_PRODUCT_LINE": {
      const productLine = (action.payload) ? action.payload : initialState.productLine;

      return {
        ...state,
        productLine: productLine,
        productLineId: productLine.productLineId
      };
    }
    case "SET_DISTRIBUTOR": {
      const distributor = (action.payload) ? action.payload : initialState.distributor;

      return {
        ...state,
        distributor: distributor,
        distributorId: distributor.distributorId
      };
    }
    case "SET_OPPORTUNITY": {
      const opportunity = (action.payload) ? action.payload : initialState.opportunity;

      return {
        ...state,
        opportunity: opportunity,
        opportunityId: opportunity.opportunityId
      };
    }
    case "SET_INTERLOCK": {
      const interlock = (action.payload) ? action.payload : initialState.interlock;

      return {
        ...state,
        interlock: interlock,
        interlockId: interlock.interlockId
      };
    }
    case "SET_ONSITE":
      return { ...state, onsite: Boolean(action.payload) };
    case "SET_ONSITE_DETAIL":
      return { ...state, onsiteDetail: action.payload };
    case "SET_SERVICE_REQUEST": {
      const serviceRequest = (action.payload) ? action.payload : initialState.serviceRequest;

      return {
        ...state,
        serviceRequest: serviceRequest,
        serviceRequestId: serviceRequest.srNumber
      };
    }
    case "SET_ENTRY":
      return { ...initialState, ...action.payload };
    case "CLEAR_ALL_INPUT":
      return cloneDeep(initialState);
    case "DELETE_ENTRY":
      if (state.id === action.entry.id) {
        return cloneDeep(initialState);
      }

      return state;
    case "SUBMIT_ENTRY":
      if (state.id === action.entry.id) {
        return cloneDeep(initialState);
      }

      return state;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./app/reducers/entryReducer.js